import { localToday } from './dates'

export const LEAVE_MODULE_DEV_KEY = 'clnicl_dev_leave_module'
export const LEAVE_PREVIEW_DATE_KEY = 'clnicl_dev_leave_as_of'

export type ProductType = 'pms' | 'ppt'

function isLocalHost(): boolean {
  if (typeof window === 'undefined') return false
  const host = window.location.hostname
  return host === 'localhost' || host === '127.0.0.1'
}

/**
 * Leave is a PPT product module. A PMS tenant cannot enable it.
 * A dev override only applies on localhost and still requires PPT.
 */
export function isLeaveModuleEnabled(input: {
  productType: ProductType
  tenantEnabled?: boolean
  devOverride?: boolean | null
}): boolean {
  if (input.productType !== 'ppt') return false
  if (input.devOverride === true) return true
  if (input.devOverride === false) return false
  return input.tenantEnabled === true
}

export function readLeaveModuleDevOverride(): boolean | null {
  if (!isLocalHost()) return null
  const raw = window.localStorage.getItem(LEAVE_MODULE_DEV_KEY)
  if (raw === 'on') return true
  if (raw === 'off') return false
  return null
}

export function readLeavePreviewDate(): string | null {
  if (!isLocalHost()) return null
  const raw = window.localStorage.getItem(LEAVE_PREVIEW_DATE_KEY)
  if (!raw || !/^\d{4}-\d{2}-\d{2}$/.test(raw)) return null
  return raw
}

export function leaveToday(now = new Date()): string {
  return readLeavePreviewDate() || localToday(now)
}
